var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('Header'),_c('div',{staticClass:"cont"},[_c('div',{staticClass:"video-container"},[_c('video',{attrs:{"width":"560","height":"315","controls":""}},[_c('source',{attrs:{"src":require('@/assets/videos/PWC-Safety-101.mp4'),"type":"video/mp4"}}),_vm._v(" Your browser does not support the video tag. ")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }